<template>
  <div class="zj-emergency-videomonitor-panel">
    <div class="zj-emergency-videomonitor-header">
      <span class="header-title">视频监控</span>
      <div class="arrow-pic"></div>
      <div class="icon-spread" @click="isVisiable=true"></div>
    </div>
    <div class="zj-emergency-videomonitor-search-box">
      <input type="text" placeholder="搜索视频监控点" class="zj-emergency-videomonitor-search-box-input" v-model="searchText"/>
      <div class="zj-emergency-videomonitor-search-box-btn" @click="searchByCondition(searchText)"></div>
    </div>
    <div class="zj-emergency-videomonitor-list">
      <div class="zj-emergency-videomonitor-list-container">
        <VideoMonitorControl
          @spread="cameraSpread"
          v-for="item in cameras"
          :key="item.cameraId"
          :cameraId="item.cameraId"
          :streamUrl="item.streamUrl"
          :autoplay="item.autoplay"
          :cameraName="item.cameraName"
        />
      </div>
    </div>
    <el-dialog
      class="emergencyoperations-dialog video-monitor"
      custom-class="bg3"
      top="20vh"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isVisiable"
      :destroy-on-close="true"
    >
      <VideoMonitorPopup @handlerclose="isVisiable=false" />
    </el-dialog>

    <el-dialog
      class="emergencyoperations-dialog video-monitor"
      custom-class="bg3"
      top="20vh"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isGrowVisiable"
      :destroy-on-close="true"
    >
      <VideoMonitorGrow
        :cameraId="currentCameraId"
        :cameraName="currentCameraName"
        :streamUrl="currentStreamUrl"
        @spread="cameraSpread"
        @handlerclose="isGrowVisiable=false"
      />
    </el-dialog>
  </div>
</template>

<script>
import VideoMonitorControl from "./Component-VideoMonitorControl";
import VideoMonitorPopup from "./Component-VideoMonitor";
import VideoMonitorGrow from "./Component-VideoMonitorGrow";
import MyApis from "../../../../apis";
import dataServerApi from "../../../../../../../request/dataServerApi";
export default {
  name: "ZJEmergencyVideoMonitorPanel",
  componentName: "ZJEmergencyVideoMonitorPanel",
  components: {
    VideoMonitorControl: VideoMonitorControl,
    VideoMonitorPopup: VideoMonitorPopup,
    VideoMonitorGrow: VideoMonitorGrow
  },
  data: function() {
    return {
      isVisiable: false,
      isGrowVisiable: false,
      cameras: [],
      camerasList: [],
      currentCameraId: "",
      currentCameraName: "",
      currentStreamUrl: "",
      searchText:""
    };
  },
  created() {
    this.search();
  },
  methods: {
    cameraSpread(cameraId, cameraName,streamUrl) {
      console.log(cameraId)
      console.log(cameraName)
      console.log(streamUrl)
      this.currentCameraId = cameraId;
      this.currentCameraName = cameraName;
      this.currentStreamUrl = streamUrl;
      this.isGrowVisiable = true;
    },
    // eslint-disable-next-line no-unused-vars
    search() {
      let that = this;
      new MyApis.EquipmentApi()
        .GetRegionEquipment({
          EquipmentType: "Monitor"
        })
        .then(r => {
          r = r.data.Data;
          console.log("视频监控");
          that.convertToCameraList(r);
        })
        .catch(e => {
          console.error(e);
          that.$message({
            message: e.RspMsg ? e.RspMsg : "搜索视频失败！",
            type: "error"
          });
        });
    },
    convertToCameraList(list) {
      for (let i = 0; i < list.length; i++) {
        var regionData = list[i];
        if (!regionData.Devices) continue;
        for (let j = 0; j < regionData.Devices.length; j++) {
          var deviceData = regionData.Devices[j];
          this.camerasList.push(deviceData);
        }
      }
      this.searchByCondition("");
    },
    searchByCondition(searchText) {
      let arr = [];
      if (searchText == null || searchText == "") {
        this.camerasList.forEach((el, index) => {
          if (index < 4) {
            this.getStreamUrlByCode(el.DeviceId,index);
            arr.push({
              streamType: 1,
              autoplay: false,
              cameraId: el.DeviceId,
              cameraName: el.DeviceName
            });
          }
        });
      } else {
        this.camerasList.forEach(el => {
          if (el.DeviceName.indexOf(searchText) >= 0) {
            if (arr.length < 5) {
             this.getStreamUrlByCode(el.DeviceId,arr.length);
            }
            arr.push({
              streamType: 1,
              autoplay: false,
              cameraId: el.DeviceId,
              cameraName: el.DeviceName
            });
          }
        });
      }
      this.cameras = arr.slice(0, 4);
      if (this.cameras.length > 0) {
        this.cameras[0].autoplay = true;
      }
    },

  getStreamUrlByCode(code,index) {
      let params= {"indexCode":code}
      // let params= {"indexCode":"865ac4e15d0947d7bec6349ddf380f2d"}
      dataServerApi.getstreamurl(params).then(res=>{
        // console.log("streamUrl_res")s
        // console.log(res)
        if(res.code==0){
          let streamUrl = res.data.data.url;
          this.cameras[index].streamUrl =streamUrl;
          // console.log("streamUrl")
          // console.log(streamUrl)
          // console.log(this.cameras)
        }
      })
    }
  }
};
</script>